import { render } from "./EditFieldActions.vue?vue&type=template&id=6e4c46c2"
import script from "./EditFieldActions.vue?vue&type=script&lang=ts"
export * from "./EditFieldActions.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
